export default __webpack_public_path__ + "static/media/sanmat9.274c8a53.jpg";